import AxiosGlobalInstance, {
  AxiosPromise,
  IConsorcieiResponse,
} from "@/services/index";

/**
 * Upload a image to BKOF user register bucket
 * @param {string} base64String
 * @return {AxiosPromise<IConsorcieiResponse<Record<string, unknown>>>} Promise with axios response
 */
export function uploadImage(
  base64String: string
): AxiosPromise<IConsorcieiResponse<Record<string, unknown>>> {
  return AxiosGlobalInstance.post(`/images/save`, {
    base64String,
  });
}
